import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
const POST_API = "https://notregrandbleu.herokuapp.com/post/";
const Contact_API = "https://notregrandbleu.herokuapp.com/contact/";
const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
}; 
@Injectable({
  providedIn: 'root'
})
export class PostService {

  constructor(private http: HttpClient , @Inject(DOCUMENT) private dom) { }

  public AfficherPosts(): Observable<any> {
    return this.http.get(POST_API , httpOptions);
  }
  addPosts(post): Observable<any> {
    return this.http.post(POST_API + "addPost", post ,httpOptions );
  }
  delete(id): Observable<any> {
    return this.http.get(POST_API + "deletePost/"+ id ,httpOptions );
  }

  getById(id): Observable<any> {
    return this.http.get(POST_API + "getPostById/"+ id ,httpOptions );
  }
  sendPost(user): Observable<any>
  {
    return this.http.post(Contact_API + "send", user ,httpOptions );
  }
  public AfficherBlogs(): Observable<any> {
    return this.http.get(POST_API + "getFirstPost" , httpOptions);
  }
  public afficherByN(id): Observable<any> {
    return this.http.get(POST_API + 'getBlogsByN/' + id, httpOptions)
  }

/*   setCanonicalURL(url?: string)  {
    const canURL = url == undefined ? this.dom.URL : url;
    const link: HTMLLinkElement = this.dom.createElement('meta');
    link.setAttribute('property', 'og:url');
    link.setAttribute('content', canURL);
    return link ;
  }
  setTitleMeta( titles?:string)
  {
    const canURLtitle = titles == undefined ? this.dom.URL : titles;
    const linkTitle: HTMLLinkElement = this.dom.createElement('meta');
    linkTitle.setAttribute('property', 'og:title');
    linkTitle.setAttribute('content', canURLtitle);

    this.dom.head.appendChild(linkTitle); 
    return linkTitle ;
  } */


}
